import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const companyJobFunctionsApi = createApi({
  reducerPath: "CompanyJobFunctionsApi ",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: [
    "CompanyJobFunctions",
    "CompanyJobFunctionsMappings",
    "CompanySubJobFunctions",
  ],
  endpoints: builder => ({
    /**
     * @Services - Company Functions Mapping
     */
    fetchAllCompanyFunctionsMapping: builder.query({
      query: ({ company_id }) => ({
        url: `/company/${company_id}/company-job-function-mappings/`,
        method: "GET",
      }),
      providesTags: ["CompanyJobFunctionsMappings"],
    }),
    fetchPaginatedCompanyJobFunctions: builder.query({
      query: ({ company_id, page = 1, page_size = 10 }) => ({
        url: `/company/${company_id}/company-job-functions/`,
        method: "GET",
        params: { page, page_size },
      }),
      providesTags: ["CompanyJobFunctions"],
    }),
    createCompanyJobFunction: builder.mutation({
      query: ({ company_id, name, description }) => ({
        url: `/company/${company_id}/company-job-function/`,
        method: "POST",
        body: {
          name,
          description,
        },
      }),
      invalidatesTags: ["CompanyJobFunctions"],
    }),

    fetchPaginatedCompanySubJobFunctions: builder.query({
      query: ({ company_id, page = 1, page_size = 10 }) => ({
        url: `/company/${company_id}/company-sub-job-functions/`,
        method: "GET",
        params: { page, page_size },
      }),
      providesTags: ["CompanySubJobFunctions"],
    }),

    fetchCompanyJobFunctionById: builder.query({
      query: ({ company_id, company_job_function_id }) => ({
        url: `/company/${company_id}/company-job-function/${company_job_function_id}/`,
        method: "GET",
      }),
      providesTags: ["CompanyJobFunctions"],
    }),

    createCompanySubJobFunction: builder.mutation({
      query: ({ company_id, name, description, company_job_function_id }) => ({
        url: `/company/${company_id}/company-sub-job-function/`,
        method: "POST",
        body: {
          name,
          description,
          company_job_function_id,
        },
      }),
      invalidatesTags: ["CompanySubJobFunctions", "CompanyJobFunctions"],
    }),

    updateCompanySubJobFunction: builder.mutation({
      query: ({
        company_id,
        company_sub_job_function_id,
        name,
        description,
        company_job_function_id,
      }) => ({
        url: `/company/${company_id}/company-sub-job-function/${company_sub_job_function_id}/`,
        method: "PUT",
        body: {
          name,
          description,
          company_job_function_id,
        },
      }),
      invalidatesTags: ["CompanySubJobFunctions", "CompanyJobFunctions"],
    }),

    updateCompanyJobFunction: builder.mutation({
      query: ({ company_id, company_job_function_id, name, description }) => ({
        url: `/company/${company_id}/company-job-function/${company_job_function_id}/`,
        method: "PUT",
        body: {
          name,
          description,
        },
      }),
      invalidatesTags: ["CompanyJobFunctions", "CompanySubJobFunctions"],
    }),

    deleteCompanyJobFunction: builder.mutation({
      query: ({ company_id, company_job_function_id }) => ({
        url: `/company/${company_id}/company-job-function/${company_job_function_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["CompanyJobFunctions"],
    }),

    deleteCompanySubJobFunction: builder.mutation({
      query: ({ company_id, company_sub_job_function_id }) => ({
        url: `/company/${company_id}/company-sub-job-function/${company_sub_job_function_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["CompanySubJobFunctions", "CompanyJobFunctions"],
    }),

    downloadCompanyJobFunctions: builder.mutation({
      query: ({ company_id }) => ({
        url: `/company/${company_id}/company-job-function/download/`,
        method: "GET",
        responseHandler: (response: any) => response.blob(),
      }),
    }),

    uploadCompanyJobFunctions: builder.mutation({
      query: ({ company_id, formData }) => ({
        url: `/company/${company_id}/company-job-function/upload/?active=true`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["CompanyJobFunctions"],
    }),
  }),
});

export const {
  useFetchAllCompanyFunctionsMappingQuery,
  useFetchPaginatedCompanyJobFunctionsQuery,
  useCreateCompanyJobFunctionMutation,
  useUpdateCompanyJobFunctionMutation,
  useFetchPaginatedCompanySubJobFunctionsQuery,
  useFetchCompanyJobFunctionByIdQuery,
  useCreateCompanySubJobFunctionMutation,
  useUpdateCompanySubJobFunctionMutation,
  useDeleteCompanyJobFunctionMutation,
  useDeleteCompanySubJobFunctionMutation,
  useDownloadCompanyJobFunctionsMutation,
  useUploadCompanyJobFunctionsMutation,
} = companyJobFunctionsApi;
